import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ValueAdditionTwoDto } from "./addition-type-two.dto";

export class valueAdditionTwoResponse extends GlobalResponseObject{

      data?: ValueAdditionTwoDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ValueAdditionTwoDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}